import { Injectable } from '@angular/core';
import { BaseWooCommerceV2ApiService } from './base-woo-commerce-v2-api.service';
import { map, Observable } from 'rxjs';
import { WooCommerceCoupon } from '../../../interfaces/woo-commerce/api/coupon/coupon-api.interface';
import { mapHappyCouponsToWooCoupons } from '../../happy/happy-api-mappers';

@Injectable({ providedIn: 'root' })
export class WooCommerceCouponApiService extends BaseWooCommerceV2ApiService {
  private readonly happyCouponsUrl: string = '/cart/coupons';
  private readonly happyCartUrl: string = '/cart';

  addCoupon(code: string): Observable<WooCommerceCoupon> {
    return this.post(this.happyCouponsUrl, { code }).pipe(
      map(() => ({
        code,
        type: 'fixed',
        totals: {
          currency_code: 'USD',
          currency_symbol: '$',
          currency_minor_unit: 2,
          currency_decimal_separator: '.',
          currency_thousand_separator: ',',
          currency_prefix: '$',
          currency_suffix: '',
          total_discount: '0',
          total_discount_tax: '0'
        }
      }))
    );
  }

  removeCoupon(coupon: WooCommerceCoupon): Observable<WooCommerceCoupon> {
    return this.delete(
      `${this.happyCouponsUrl}/${encodeURIComponent(String(coupon.coupon_id))}`
    ).pipe(
      map(() => ({
        coupon_id: coupon.coupon_id,
        code: coupon.code,
        type: 'fixed',
        totals: {
          currency_code: 'USD',
          currency_symbol: '$',
          currency_minor_unit: 2,
          currency_decimal_separator: '.',
          currency_thousand_separator: ',',
          currency_prefix: '$',
          currency_suffix: '',
          total_discount: '0',
          total_discount_tax: '0'
        }
      }))
    );
  }

  getCoupons(): Observable<WooCommerceCoupon[]> {
    return this.get(this.happyCartUrl).pipe(
      map((response: any) =>
        mapHappyCouponsToWooCoupons(
          (response?.data || response || {})?.coupons || []
        )
      )
    );
  }
}
